import { render, staticRenderFns } from "./ChoirMinistryCard.vue?vue&type=template&id=0fed6002&scoped=true&"
import script from "./ChoirMinistryCard.vue?vue&type=script&lang=js&"
export * from "./ChoirMinistryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed6002",
  null
  
)

export default component.exports